
import React from "react";
import { FaArrowCircleRight } from "react-icons/fa";

function QuienesSomos() {
    return (
        <section
            className="empresa-identidad"
            id="empresa-identidad"
        >
            <div className="empresa-section-label">
                <span>01</span>
                <span>QUIÉNES SOMOS</span>
            </div>

            <div className="empresa-identidad-grid">
                <div className="empresa-identidad-heading">
          <span className="empresa-eyebrow">
            UNA VISIÓN EN MOVIMIENTO
          </span>

                    <h2>
                        El futuro
                        <br />
                        comienza
                        <br />
                        con una idea.
                    </h2>

                    <div
                        className="empresa-heading-decoration"
                        aria-hidden="true">
                        <span />
                        <span />
                        <span />
                    </div>

                    <span className="empresa-side-note">
            VEMASMAS / MÉXICO
          </span>
                </div>

                <div className="empresa-identidad-copy">
                    <p className="empresa-lead">
                        Vemasmas es una empresa mexicana de tecnología
                        e innovación, reconocida por su liderazgo en
                        el desarrollo de soluciones digitales, análisis
                        de datos y tecnología basada en UAS
                        (Unmanned Aircraft Systems).
                    </p>

                    <p>
                        Nuestro trabajo transforma realidades. Combinamos
                        conocimiento, creatividad y pensamiento estratégico
                        para desarrollar soluciones que responden a los
                        desafíos de un entorno en constante evolución.
                    </p>

                    <p>
                        Nuestra visión está encabezada por nuestro CEO,
                        Oscar Fredy González Rivera, figura clave en el
                        ecosistema tecnológico de América Latina.
                    </p>

                    <p>
                        En Vemasmas creemos firmemente que el futuro se
                        construye con talento, innovación y compromiso.
                    </p>

                    <a
                        href="#empresa-esencia"
                        className="empresa-inline-link"
                    >
                        CONOCE NUESTRA ESENCIA
                        <FaArrowCircleRight />
                    </a>
                </div>
            </div>

            <svg
                className="empresa-editorial-trace"
                viewBox="0 0 1200 230"
                fill="none"
                preserveAspectRatio="none"
                aria-hidden="true"
            >
                <path d="M0 60 H360 Q390 60 390 90 V145 Q390 175 420 175 H720 Q750 175 750 145 V70 Q750 40 780 40 H1200" />
                <path d="M0 67 H353 Q383 67 383 97 V152 Q383 182 413 182 H713 Q743 182 743 152 V77 Q743 47 773 47 H1200" />
            </svg>
        </section>
    );
}

export default QuienesSomos;
